<template>
  <span :class="{ 'text-muted': textMuted }">&nbsp;&nbsp;•&nbsp;&nbsp;</span>
</template>
<script lang="ts">
export default {
  props: {
    textMuted: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
